
import * as React from "react";
import { useParams } from "react-router-dom";
import RemotionPlayer from "../../remotion/RemotionPlayer";
import { Layer, useProject } from "../../shared";
import Page from "../templates/Page";

export const roundEven = (x: number) => {
  let result = Math.round(x);
  while (result % 2 !== 0) {
      result -= 1;
  }
  return result;
}

function Preview() {
    const { id } = useParams();
    const { project } = useProject(id || "-1");
    if (!project) {
        return (
            <div>
                Project Not Found
            </div>
        )
    }
    // resize dimensions to fit in window
    const w = roundEven(window.innerWidth);
    const h = roundEven(project.dimensions.height * w / project.dimensions.width);
    project.dimensions.width = w;
    project.dimensions.height = h;
    const resizedLayers: Layer[] = [];
    project.layers.forEach(layer => {
      const h = roundEven(layer.dimensions.height * w / layer.dimensions.width);
      resizedLayers.push({
        ...layer,
        dimensions: {
          width: w,
          height: h
        }
      })
    });
    project.layers = resizedLayers;
    return (
      <Page>
        <RemotionPlayer project={project} />  
      </Page>
    );
}

export default Preview;